"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductStore = exports.ProductContainer = exports.ProductSubscriber = exports.productStore = exports.PRODUCT_STORE_NAME = void 0;
const react_sweet_state_1 = require("react-sweet-state");
const actions_1 = require("./actions");
const state_1 = require("./state");
exports.PRODUCT_STORE_NAME = 'monera-product-store';
exports.productStore = (0, react_sweet_state_1.createStore)({
    actions: actions_1.productActions,
    initialState: state_1.initialProductState,
    name: exports.PRODUCT_STORE_NAME
});
exports.ProductSubscriber = (0, react_sweet_state_1.createSubscriber)(exports.productStore);
exports.ProductContainer = (0, react_sweet_state_1.createContainer)(exports.productStore, {
    onInit: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialProductState),
    onUpdate: () => ({ setState }, { initialState }) => setState(initialState !== null && initialState !== void 0 ? initialState : state_1.initialProductState)
});
exports.useProductStore = (0, react_sweet_state_1.createHook)(exports.productStore);
__exportStar(require("./selectors"), exports);
__exportStar(require("./types"), exports);
